// ** Third Party Components
import Select from 'react-select';

// ** Utils
import { selectThemeColors } from '@utils';

// ** Reactstrap Imports
import { Row, Col, Card, CardTitle } from 'reactstrap';

// ** Styles

const CustomFilterRoad = ({
  handleFetching,
  sort,
  sortColumn,
  searchTerm,
  rowsPerPage,
  currentPillar,
  setCurrentPillar,
  totalPillars
}) => {
  // ** User filter options
  const pillarOptions = [
    { value: 'EMPTY', label: 'Seleccionar Pilar' },
    { value: 'EMOTIONS', label: 'Emociones' },
    { value: 'PURPOSE', label: 'Sentido de Vida' },
    { value: 'RELATIONS', label: 'Relaciones' },
    { value: 'SELF_ESTEEM', label: 'Amor Propio' },
    { value: 'TRANSFORMATION', label: 'Transformaciones' }
  ];

  return (
    <Card body>
      <Row>
        <Row>
          <Col>
            <CardTitle tag="h4">Filtro de búsqueda</CardTitle>
            <Col md="6">
              <Select
                isClearable={false}
                value={currentPillar}
                options={pillarOptions}
                className="react-select"
                classNamePrefix="select"
                theme={selectThemeColors}
                onChange={async (data) => {
                  setCurrentPillar(() => data);
                  handleFetching({
                    _sort: sort,
                    _sortColumn: sortColumn,
                    _page: 1,
                    _q: searchTerm,
                    _perPage: rowsPerPage,
                    _pillar: data.value
                  });
                }}
              />
            </Col>
          </Col>
          <Col md="6">
            <Row>
              <Col md="12">
                <span
                  style={{
                    fontWeight: 'bold',
                    color: '#6d6b7',
                    fontSize: 13
                  }}
                >
                  PILARES INICIADOS:
                </span>
              </Col>
              <Col>
                <div
                  className="text-center"
                  style={{
                    color: '#6d6b7b',
                    fontSize: 26
                  }}
                >
                  {totalPillars.emotions}
                </div>
                <div
                  className="text-center"
                  style={{
                    fontSize: 10
                  }}
                >
                  Emociones
                </div>
              </Col>
              <Col>
                <div
                  className="text-center"
                  style={{
                    color: '#6d6b7b',
                    fontSize: 26
                  }}
                >
                  {totalPillars.relations}
                </div>
                <div
                  className="text-center"
                  style={{
                    fontSize: 10
                  }}
                >
                  Relaciones
                </div>
              </Col>
              <Col>
                <div
                  className="text-center"
                  style={{
                    color: '#6d6b7b',
                    fontSize: 26
                  }}
                >
                  {totalPillars.transformation}
                </div>
                <div
                  className="text-center"
                  style={{
                    fontSize: 10
                  }}
                >
                  Transformacion
                </div>
              </Col>
              <Col>
                <div
                  className="text-center"
                  style={{
                    color: '#6d6b7b',
                    fontSize: 26
                  }}
                >
                  {totalPillars.purpose}
                </div>
                <div
                  className="text-center"
                  style={{
                    fontSize: 10
                  }}
                >
                  Sentido de la vida
                </div>
              </Col>
              <Col>
                <div
                  className="text-center"
                  style={{
                    color: '#6d6b7b',
                    fontSize: 26
                  }}
                >
                  {totalPillars.selfEsteem}
                </div>
                <div
                  className="text-center"
                  style={{
                    fontSize: 10
                  }}
                >
                  Amor Propio
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Row>
    </Card>
  );
};

export default CustomFilterRoad;
